import axios from 'axios';

export const getMySubscriptions = async () => {
    try {
        const response = await axios.get('/api/my-subscriptions', {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching my subscriptions:', error);
        throw error;
    }
};
